import { ETenderType, ITender } from 'types/tender'
import dayjs from 'dayjs';

export function tenderTypeToTitle(type: ETenderType) {
  return `${type}_title`
}

export function hasTenderPassedStartDate(tender: ITender) {
  return dayjs(Number(tender.startTime) * 1000).isBefore(new Date())
}

export function hasTenderPassedDocDeadline(tender: ITender) {
  return dayjs(Number(tender.docSubmissionDeadline) * 1000).isBefore(new Date())
}
